import * as React from "react";
import { useMemo, useState } from "react";

import "../../../styles/main_style.css";
import "./TabControl_style.css";
import FlexRow from "../Flexbox/FlexRow";

type Props = Readonly<{
    id: string;
    tabs: Array<{ id: string; label: string }>;
    selectedTab?: string | null;
    isDeselectEnabled?: boolean;
    onSelectedTabChange?: (newTab: string | null) => void;
}>;

export default function TabControl({
    id,
    tabs,
    selectedTab,
    isDeselectEnabled = true,
    onSelectedTabChange,
}: Props): JSX.Element {
    const tabComponents = useMemo(() => {
        return (
            <FlexRow wrap={true}>
                {tabs.map((tab) => {
                    return (
                        <TabComponent
                            id={tab.id}
                            key={tab.id}
                            label={tab.label}
                            parentID={id}
                            isSelected={selectedTab === tab.id}
                            onClick={() => {
                                if (selectedTab === tab.id) {
                                    if (isDeselectEnabled) {
                                        onSelectedTabChange?.(null);
                                    }
                                } else {
                                    const value = tab.id;
                                    onSelectedTabChange?.(value);
                                }
                            }}
                        />
                    );
                })}
            </FlexRow>
        );
    }, [id, tabs, selectedTab, isDeselectEnabled, onSelectedTabChange]);

    return <div className="tab-control-container">{tabComponents}</div>;
}

type TabComponentProps = Readonly<{
    id: string;
    label: string;
    parentID: string;
    isSelected: boolean;
    onClick: () => void;
}>;

function TabComponent({
    id,
    label,
    isSelected,
    parentID,
    onClick,
}: TabComponentProps): JSX.Element {
    const classes = useMemo<string>(() => {
        return "tab-component".concat(isSelected ? " selected" : "");
    }, [isSelected]);

    return (
        <div
            className={classes}
            id={"tab-component-".concat(parentID).concat("-").concat(id)}
            onClick={() => onClick()}
        >
            {label}
        </div>
    );
}
